import { FC, ReactNode } from 'react';

import { Snackbar, Text } from '@hh.ru/magritte-ui';
import {
    CheckCircleFilledSize24,
    ExclamationCircleFilledSize24,
    MinusCircleFilledSize24,
} from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { MagritteNotificationType } from 'store/models/notification';

interface NotificationProps {
    type: MagritteNotificationType;
    trlNotification?: string;
    text?: string;
    onClose: () => void;
    showClose?: boolean;
    dataQa?: string;
    align?: 'top' | 'bottom';
    autohideTime?: number;
    onAction?: () => void;
    actionLabel?: string;
    additionalContent?: ReactNode;
    description?: string;
}

const Notification: FC<NotificationProps> = ({
    type,
    trlNotification,
    text,
    onClose,
    showClose = true,
    dataQa,
    align = 'bottom',
    autohideTime = 6000,
    actionLabel,
    onAction,
    additionalContent,
    description,
}) => {
    const trl = useTrls();

    const addonIcons = {
        [MagritteNotificationType.Error]: <MinusCircleFilledSize24 initialColor="negative" />,
        [MagritteNotificationType.Warning]: <ExclamationCircleFilledSize24 initialColor="warning" />,
        [MagritteNotificationType.Success]: <CheckCircleFilledSize24 initialColor="positive" />,
    };

    return (
        <Snackbar
            data-qa={dataQa}
            addon={addonIcons[type]}
            autohideTime={autohideTime}
            onClose={onClose}
            showClose={showClose}
            align={align}
            actionLabel={actionLabel}
            onAction={onAction}
        >
            {text || trl(trlNotification)}
            {description && (
                <Text typography="label-3-regular" style="secondary">
                    {trl(description)}
                </Text>
            )}
            {!description && additionalContent}
        </Snackbar>
    );
};

export default Notification;
